// extracted by mini-css-extract-plugin
export default {"wrapper":"InformationSection_wrapper__NxPrD","icon":"InformationSection_icon__B54yZ","text":"InformationSection_text__dZ3-i"};